import moment from 'moment';
import api from './config';
import { getAuthHeaders } from '../utils/authUtils';

export interface AppData {
  id: string;
  landed: number;
  clickOut: number;
  percentage: number;
}

export interface MainRowData {
  name: string;
  url: string;
  path: string;
  totalLanded: number;
  totalClickOut: number;
  totalPercentage: number;
  apps: AppData[];
}

export const dashboardService = {
  getDashboardData: async (params?: { startDate: Date; endDate: Date }): Promise<MainRowData[]> => {
    const response = await api.get<MainRowData[]>('/mowpod/admin/linkouts-with-impressions/', { 
      headers: getAuthHeaders(),
      params: params ? {
        startDate: moment(params.startDate).startOf('day').format(),
        endDate: moment(params.endDate).endOf('day').format()
      } : undefined
    });
    return response.data;
  },

  getAppDetails: async (appId: string): Promise<AppData> => {
    const response = await api.get<AppData>(`/mowpod/admin/linkouts-with-impressions/${appId}`, { 
      headers: getAuthHeaders() 
    });
    return response.data;
  },

  // Add more dashboard-related API calls as needed
}; 